import { useNavigate } from "react-router-dom";
import { useCookieStore } from '../../store/cookiestore';

export default function CookieBanner() {
  const { cookieConsent, acceptCookies, rejectCookies } = useCookieStore();

  // Already decided — don't show banner
  if (cookieConsent !== null) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 md:px-6 md:pb-6">
      <div className="max-w-4xl mx-auto bg-[#02160e] border border-green-900/40 rounded-2xl px-5 py-5 shadow-2xl shadow-black/60 backdrop-blur-sm">
        <div className="flex flex-col md:flex-row md:items-center gap-4">

          {/* TEXT */}
          <div className="flex-1">
            <p className="text-sm font-semibold text-white mb-1">
              🍪 Usamos cookies
            </p>
            <p className="text-xs text-gray-400 leading-relaxed">
              Utilizamos cookies propias y de terceros para mejorar tu experiencia,
              analizar el tráfico y personalizar el contenido. Puedes aceptar todas
              las cookies o rechazar las no esenciales. Consulta nuestra{" "}
              <a
                href="/tickets-store/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-400/80 hover:text-green-400 underline transition"
              >
                Política de Cookies
              </a>
              .
            </p>
          </div>

          {/* BUTTONS */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={rejectCookies}
              className="px-4 py-2 rounded-xl border border-green-900/50 text-gray-400 text-xs tracking-widest uppercase hover:border-green-700/50 hover:text-white transition"
            >
              Rechazar
            </button>
            <button
              onClick={acceptCookies}
              className="px-4 py-2 rounded-xl bg-green-500 text-black text-xs font-bold tracking-widest uppercase hover:bg-green-400 transition"
            >
              Aceptar
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
